export async function downloadReport(http, url, params, fallbackFileName) {
  try {
    const response = await http.get(url, {
      params,
      responseType: 'blob',
      transformResponse: data => data
    })
    const contentType = response.headers['content-type'] || ''
    if (contentType.includes('application/json')) {
      throw new Error(await readBlobError(response.data))
    }

    const blob = new Blob([response.data], { type: contentType })
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = resolveFileName(response.headers['content-disposition'], fallbackFileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(downloadUrl)
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      throw new Error(await readBlobError(error.response.data))
    }
    throw error
  }
}

function resolveFileName(contentDisposition, fallbackFileName) {
  if (!contentDisposition) {
    return fallbackFileName
  }
  const utf8Match = contentDisposition.match(/filename\*=utf-8''([^;]+)/i)
  if (utf8Match && utf8Match[1]) {
    return decodeURIComponent(utf8Match[1])
  }
  const normalMatch = contentDisposition.match(/filename="?([^";]+)"?/i)
  return normalMatch && normalMatch[1] ? normalMatch[1] : fallbackFileName
}

async function readBlobError(blob) {
  try {
    const text = await blob.text()
    const payload = JSON.parse(text)
    return payload.msg || payload.message || '导出失败，请稍后重试'
  } catch (error) {
    return '导出失败，请稍后重试'
  }
}
